<template>
<m-pageframe
    title="Webchat Widget Settings: {organization_label}"
>
<v-container
    fluid
>
    <v-list-item
        v-for="(item, index) in settings"
        :key="index"
    >
        <v-list-item-avatar>
            <v-icon>
                mdi-cog
            </v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
            <v-list-item-title>
                {{item.label}}
            </v-list-item-title>

            <v-list-item-subtitle
                v-if="item.is_default"
            >
                Default
            </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
            <v-menu 
                bottom 
                offset-y  
            >
                <template v-slot:activator="{ on }">
                    <v-icon 
                        v-on="on"
                    >
                        mdi-dots-vertical
                    </v-icon>
                    
                </template>

                <v-list>
                    <v-list-item
                        v-for="(menu_item, menu_item_index) in getMenuItems(item)"
                        :key="menu_item_index"
                        v-on:click="menu_item.action(item)"
                    >
                        <v-list-item-title>{{ menu_item.text }}</v-list-item-title>
                    </v-list-item>
                </v-list>

            </v-menu> 
        </v-list-item-action>
        </v-list-item>

    <m-icon-bar
        v-on:add="onClickAddWidgetSettings"
    />

    <v-divider
        style="margin-top: 15px; margin-bottom: 15px"
    />

    <m-settings-organization-help-widget/>
    
    <div
        style="text-align: right; margin-top: 15px"
    >
        <v-btn
            color="secondary"
            v-on:click="onLinkToInstructions"
            style="margin-right: 10px"
        >
            Link to Instructions
        </v-btn>
        <v-btn
            color="primary"
            v-on:click="onTestWidget"
        >
            Test Widget
        </v-btn>
    </div>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    props: {
        settings: [],
    },

    mounted () {
        this.updateSettings();
    },

    methods: {
        onTestWidget() {
            this.$router.push({
                'name': 'settings-organization-test-widget',
                'params' : {
                    'organization_id' : this.$route.params.organization_id,
                },
            }).catch(e=>{}); // swallow any exception
        },

        onLinkToInstructions() {
            window.open("/app/public/widget-pixel-code-instructions","_blank");
        },

        updateSettings() {
            this.$rc.showSpinner();

            let search = {
                'organization_id' : this.$route.params.organization_id,

                sort: 'is_default:desc|label:asc'
            };
            
            this.$rc.searchWidgetSettings(
                search,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.settings = data.results;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        getMenuItems(setting)
        {
            if ( setting.is_default )
            {
                return [
                    { 'text' : 'Edit...', 'action' : this.onClickEdit },
                ];
            }

            return [
                    { 'text' : 'Edit...', 'action' : this.onClickEdit },
                    { 'text' : 'Delete...', 'action' : this.onClickDelete },
                    { 'text' : 'Promote to default', 'action' : this.onClickPromote }
                ];
        },

        onClickEdit(setting)
        {
            this.$router.push({
                'name': 'edit-widget-settings',
                'params' : {
                    'settings_id' : setting.settings_id,
                }
            }).catch(e=>{}); // swallow any exception
        },

        onClickDelete(setting)
        {
            this.$rc.confirm(
                'Delete widget settings',
                'Permenantly delete the widget settings "'+setting.label+'"?',
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'Delete', 'value' : 'confirm' },
                ],
                (response) => {
                    if ( response != 'confirm' ) return;
                    this.doDeleteAfterConfirm(setting);
                },
            );
        },

        doDeleteAfterConfirm(setting)
        {
            this.$rc.showSpinner();
            
            this.$rc.deleteWidgetSettings(
                setting.settings_id,
            
                (data) => {
                    this.$rc.hideSpinner();

                     this.updateSettings();

                    this.$rc.snackbar('Default widget settings changed.',2000);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to delete widget settings');
                },
            );
        },
        
        onClickPromote(setting)
        {
            this.$rc.showSpinner();
            
            this.$rc.promoteWidgetSettingsToDefault(
                setting.settings_id,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.updateSettings();

                    this.$rc.snackbar('Default widget settings changed.',2000);
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickAddWidgetSettings()
        {
            this.$rc.prompt({
                'title' : 'Enter the label for the new widget settings',
                'label' : 'Label',
                'after_prompt' : (value) => {
                    
                    let params = {
                        'organization_id' : this.$route.params.organization_id,
                        'label' : value,
                    };

                    this.$rc.showSpinner();
                    
                    this.$rc.createNewWidgetSettings(
                        params,
                    
                        (data) => {
                            this.$rc.hideSpinner();

                            this.updateSettings();

                            this.$rc.snackbar('New widget settings created.',2000);
                        },
                    
                        () => {
                            this.$rc.hideSpinner();
                            this.$rc.alert('Error','Unable to create new widget settings.');
                        },
                    );

                }
            });
        },
    },

    

}
</script>

<style lang="scss" scoped>

</style>